import * as angular from "angular";
import {BringozToastService} from "../../commons/services/bringoz-toast.service";

export class CancellationReasonsAlertsService {

  /* @ngInject */
  constructor(private bringozToastService: BringozToastService) {
  }

  // CREATE //
  createSuccess() {
    var message = {
      body: 'CANCEL_REASON_CREATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  createError() {
    var message = {
      body: 'CANCEL_REASON_CREATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UPDATE //
  updateSuccess() {
    var message = {
      body: 'CANCEL_REASON_UPDATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updateError() {
    var message = {
      body: 'CANCEL_REASON_UPDATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // DELETE //
  removeSuccess() {
    var message = {
      body: 'CANCEL_REASON_REMOVE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  removeError() {
    var message = {
      body: 'CANCEL_REASON_REMOVE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }


}

angular
  .module('bringoz.admin.cancellation-reasons')
  .service('cancellationReasonsAlertsService', CancellationReasonsAlertsService);
